export const api = process.env.REACT_APP_API
export const region = process.env.REACT_APP_REGION
export const user_pool = process.env.REACT_APP_USER_POOL
export const user_pool_client = process.env.REACT_APP_USER_POOL_CLIENT
export const oauth_domain = process.env.REACT_APP_OAUTH_DOMAIN
export const oauth_redirect_sign_in_url = process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN_URL
export const oauth_redirect_sign_out_url = process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT_URL
export const oauth_client_id = process.env.REACT_APP_OAUTH_CLIENT_ID